/**
 * @module common/components/base_ui/footer
 */
import React from 'react';
import moment from 'moment';
import { Link } from 'react-router';

/**
 * Main footer component
 * @author Kamil Grymuza <kamil@startupfoundry.com>
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */
const Footer = () => (
  <footer className="l-footer">
    <div className="row">
      <div className="columns small-16 medium-8">
        <ul className="footer-links">
          <li><Link to="/help/contact/">Contact Us</Link></li>
          <li><Link to="/help/">Help Center</Link></li>
          <li><Link to="/about-us/">About Us</Link></li>
          <li><a href="/blog/">Blog</a></li>
        </ul>
      </div>
      <div className="columns medium-8">
        <ul className="social-links">
          <li>
            <a href="https://www.facebook.com/crowdspring/" rel="nofollow noopener noreferrer" target="_blank">
              <i className="fa fa-facebook" />
            </a>
          </li>
          <li>
            <a href="https://twitter.com/crowdspring" rel="nofollow noopener noreferrer" target="_blank">
              <i className="fa fa-twitter" />
            </a>
          </li>
          <li>
            <a href="https://www.youtube.com/crowdspring" rel="nofollow noopener noreferrer" target="_blank">
              <i className="fa fa-youtube" />
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div className="row">
      <div className="columns medium-16">
        <p className="copyright-legal-info">
          &copy; 2008–{moment().year()} crowdSPRING, LLC.
        </p>
        <p>
          <Link to="/privacy-policy/">Privacy Policy</Link>
          <Link to="/user-agreement/">User Agreement</Link>
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./common/components/base_ui/footer.jsx